<script type="text/javascript">
	export let value = false;
	export let disabled = false;
	export let name = false;

	import { createEventDispatcher } from 'svelte';

	const dispatch = createEventDispatcher();
</script>

<label class="b-contain">
	<span><slot></slot></span>
	<input type="checkbox" disabled={disabled} bind:checked={value} name={name}
	on:change={c=>dispatch('change',c)}>
	<div class="b-input"></div>
</label>

<style type="text/css">
	.b-contain{
		margin-bottom: 0px;
	}
</style>